// Turkish translations
const tr = {
  // Header translations
  transaction: 'İşlem',
  prop: 'Prop',
  explore: 'Keşfet',
  profit: 'Kar',
  assets: 'Varlık',
  credit: 'Kredi',
  balance: 'Bakiye',
  freeMargin: 'Serbest Teminat',
  margin: 'Teminat',
  marginLevel: 'Teminat Seviyesi',
  openRealAccount: 'Gerçek Hesap Aç',
  
  // Market Watch
  marketWatch: 'Piyasa İzleme',
  favorites: 'Favoriler',
  mostActive: 'En Çok Hareket Eden',
  all: 'Tümü',
  searchSymbols: 'Sembol ara...',
  
  // Trading Actions
  buy: 'AL',
  sell: 'SAT',
  close: 'Kapat',
  
  // Trading Modal
  market: 'Piyasa',
  pending: 'Bekleyen',
  currentPrice: 'Mevcut Fiyat',
  volume: 'Hacim',
  lot: 'Lot',
  price: 'Fiyat',
  stopLoss: 'Zararı Durdur',
  takeProfit: 'Kar Al',
  optional: 'İsteğe bağlı',
  marketOrder: 'Piyasa Emri',
  pendingOrder: 'Bekleyen Emir',
  executionPrice: 'İcra Fiyatı',
  cancel: 'İptal',
  
  // Positions Panel
  openPositions: 'Açık Pozisyonlar',
  pendingOrders: 'Bekleyen Emirler',
  closedPositions: 'Kapanan Pozisyonlar',
  finance: 'Finans',
  noOpenPositions: 'Hiç açık pozisyonunuz yok. İşlem yapmaya başlayın, açık pozisyonlarınızı burada göreceksiniz.',
  noPendingOrders: 'Bekleyen emir bulunmamaktadır.',
  noClosedPositions: 'Kapanan pozisyon bulunmamaktadır.',
  noFinancialHistory: 'Finansal işlem geçmişi bulunmamaktadır.',
  
  // Common terms
  symbol: 'Sembol',
  type: 'Tip',
  pnl: 'K/Z',
  swap: 'Swap',
  commission: 'Komisyon',
  spread: 'Spread',
  time: 'Zaman',
  
  // Account info
  equity: 'Özkaynak',
  usedMargin: 'Kullanılan Teminat',
  accountBalance: 'Hesap Bakiyesi',
  
  // Connection status
  connected: 'Bağlı',
  connecting: 'Bağlanıyor...',
  disconnected: 'Bağlantı Kesildi',
  
  // Mobile-specific translations
  accountSummary: 'Hesap Özeti',
  selectField: 'Alan Seç',
  
  // Modal-specific translations
  buyOrder: 'Alış Emri',
  sellOrder: 'Satış Emri',
  
  // Navigation translations
  symbols: 'Semboller',
  chart: 'Grafik',
  positions: 'Pozisyonlar',
  
  // Account management
  account: 'Hesap',
  notifications: 'Bildirimler',
  markAllRead: 'Tümünü Okundu Olarak İşaretle',
  noNotifications: 'Bildirim yok',

  // Account creation
  createAccount: 'Hesap Oluştur',
  newAccount: 'Yeni Hesap Oluştur',
  accountType: 'Hesap Türü',
  selectAccountType: 'Hesap türünü seçin',
  password: 'Parola',
  confirmPassword: 'Parola Onayı',
  enterPassword: 'Hesap parolasını girin',
  reenterPassword: 'Parolayı tekrar girin',
  liveAccount: 'Canlı Hesap',
  demoAccount: 'Demo Hesap',
  practiceAccount: 'Pratik Hesap',
  islamicAccount: 'İslami Hesap',
  passwordMismatch: 'Parolalar eşleşmiyor!',

  // Market Watch Settings Modal
  marketWatchSettings: 'Piyasa İzleme Ayarları',
  general: 'Genel',
  display: 'Görünüm',
  generalSettings: 'Genel Ayarlar',
  displaySettings: 'Görünüm Ayarları',
  autoRefresh: 'Otomatik Yenileme',
  autoRefreshDesc: 'Fiyatları otomatik olarak yenile',
  soundAlerts: 'Ses Uyarıları',
  soundAlertsDesc: 'Fiyat değişimleri için ses uyarıları',
  updateInterval: 'Güncelleme Aralığı',
  second: 'saniye',
  seconds: 'saniye',
  showSpread: 'Spread Göster',
  showSpreadDesc: 'Alış-satış farkını göster',
  showVolume: 'Hacim Göster',
  showVolumeDesc: 'İşlem hacmini göster',
  decimalPlaces: 'Ondalık Basamak',
  colorTheme: 'Renk Teması',
  default: 'Varsayılan',
  greenRed: 'Yeşil-Kırmızı',
  blueOrange: 'Mavi-Turuncu',
  save: 'Kaydet',

  // Technical Indicators
  indicators: 'İndikatörler',
  technicalIndicators: 'Teknik İndikatörler',
  sma20: 'SMA 20',
  sma50: 'SMA 50',
  ema12: 'EMA 12',
  ema26: 'EMA 26',
  rsi14: 'RSI 14',
  bollingerBands: 'Bollinger Bantları',
  trendLine: 'Trend Çizgisi',
  dynamicTrend: 'Dinamik Trend',
  movingAverage: 'Hareketli Ortalama',
  exponentialMovingAverage: 'Üssel Hareketli Ortalama',
  relativeStrengthIndex: 'Göreceli Güç Endeksi',
  macd: 'MACD',
  stochastic: 'Stokastik',
  atr: 'ATR',
  volume: 'Hacim',
  
  // Chart loading states
  loadingChart: 'Grafik Yükleniyor...',
  initializing: 'Başlatılıyor',
  chartReady: 'Grafik Hazır',

  // Performance table
  performance: 'Başarım',
  performanceMetrics: 'Başarım Metrikleri',
  totalTrades: 'Toplam İşlem',
  winningTrades: 'Kazanan İşlem',
  losingTrades: 'Kaybeden İşlem',
  winRate: 'Kazanma Oranı',
  totalProfit: 'Toplam Kar',
  totalLoss: 'Toplam Zarar',
  netProfit: 'Net Kar',
  averageWin: 'Ortalama Kazanç',
  averageLoss: 'Ortalama Kayıp',
  profitFactor: 'Kar Faktörü',
  maxDrawdown: 'Maksimum Çekim',
  consecutiveWins: 'Ardışık Kazanç',
  consecutiveLosses: 'Ardışık Kayıp',
  totalVolume: 'Toplam Hacim',
  tradingHistory: 'İşlem Geçmişi',
  loading: 'Yükleniyor...',
  noTradeHistory: 'İşlem geçmişi bulunamadı',

  // Positions table specific translations
  id: 'ID',
  amount: 'Miktar',
  openTime: 'Açılış Zamanı',
  openPrice: 'Açılış Fiyatı',
  closePrice: 'Kapanış Fiyatı',
  stopLoss: 'Zararı Durdur',
  takeProfit: 'Kar Al',
  actions: 'İşlemler',
  edit: 'Düzenle',
  searchSymbol: 'Sembol ara...',
  loadingPositions: 'Pozisyonlar yükleniyor...',
  trading: 'İşlem',
  orders: 'Emirler',
  history: 'Geçmiş',
  openPositionsAndPending: 'Açık Pozisyonlar ve Beklemede Olanlar',
  previous: 'Önceki',
  next: 'Sonraki',
  page: 'Sayfa',
  of: '/',
  noData: 'Veri bulunamadı',
  itemsPerPage: 'Sayfa başına öğe',
  
  // Orders specific translations
  orderType: 'Emir Türü',
  orderPrice: 'Emir Fiyatı',
  currentPrice: 'Güncel Fiyat',
  placed: 'Yerleştirildi',
  expires: 'Süre Sonu',
  gtc: 'İptal Edilene Kadar',
  cancel: 'İptal Et',
  noOrdersAvailable: 'Beklemede olan emir bulunmuyor'
};

export default tr;